export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

// regex for hh:mm:ss or h:mm:ss
export const TIME_REGEX = /(?:[01]\d|2[0123]):(?:[012345]\d):(?:[012345]\d)/;
